import React, { useState, useEffect, useRef } from 'react';
import { ReactComponent as ComprasIcon } from '../../assets/icons/ComprasIcon.svg';
import { Listbox, ListboxButton, ListboxOptions, ListboxOption, Combobox } from '@headlessui/react';
import { ReactComponent as SearchIcon } from '../../assets/icons/SearchIcon.svg';
import { getAuth } from 'firebase/auth';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf'
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from 'firebase/storage';
import { useNavigate, useParams } from 'react-router-dom';
import { doc as firestoreDoc, getDoc } from 'firebase/firestore';
import { db } from '../../services/firebase';
import OrdenCompra from '../OrdenCompra';
import LoadingSpinner from '../LoadingSpinner';
const OCForm = () => {
const { id } = useParams();
const isEditing = !!id;
const [loadingOrden, setLoadingOrden] = useState(!!id);
const [isLoading, setIsLoading] = useState(false);
const [saveState, setSaveState] = useState('idle'); // 'idle' | 'saved' | 'error'
const [errorMsg, setErrorMsg] = useState('');
const [progress, setProgress] = useState(0);
const [proveedores, setProveedores] = useState([]);
const [loadingProveedores, setLoadingProveedores] = useState(true);
const [selectedProveedor, setSelectedProveedor] = useState(null);
const [mostrarOrden, setMostrarOrden] = useState(false);
const [numeroOrden, setNumeroOrden] = useState(null);
const [query, setQuery] = useState('');
const ordenRef = useRef(null);
const navigate = useNavigate();
const [articulos, setArticulos] = useState([
{
nombre: '',
categoria: '',
tipoUnidad: '',
cantidadUnidades: '',
tipoDivisa: '',
precioUnidad: '',
descuentoAplicado: '',
},
]);
const [formData, setFormData] = useState({
razonSocial: '',
cuit: '',
calle: '',
telefono: '',
correoElectronico: '',
nombreVendedor: '',
altura: '',
piso: '',
unidad: '',
codigoPostal: '',
ciudad: '',
pais: '',
entregacalle: '',
entregaaltura: '',
entregaPiso: '',
entregaunidad: '',
entregaCodigoPostal: '',
entregaCiudad: '',
entregaPais: '',
modalidadPago: '',
montoEstimado: 0
});
useEffect(() => {
const fetchProveedores = async () => {
try {
const res = await fetch('https://backend-288175208699.europe-west1.run.app/proveedores', {
headers: { Authorization: `Bearer ${await getAuth().currentUser.getIdToken()}` },
});
const data = await res.json();
const sortedProveedores = data.sort((a, b) =>
a.razonSocial.localeCompare(b.razonSocial, 'es', { sensitivity: 'base' })
);

setProveedores(sortedProveedores);
setLoadingProveedores(false);
} catch (err) {
console.error('Error al cargar proveedores:', err);
setLoadingProveedores(false);
}
};
fetchProveedores();
}, []);
// Modo edición: carga la orden existente y precarga el formulario.
useEffect(() => {
if (!isEditing) return;
const cargarOrden = async () => {
try {
const snap = await getDoc(firestoreDoc(db, 'ordenes_compra', id));
if (!snap.exists()) {
setLoadingOrden(false);
return;
}
const orden = snap.data();
setFormData(prev => ({ ...prev, ...orden }));
if (orden.razonSocial) {
setSelectedProveedor({
razonSocial: orden.razonSocial,
cuit: orden.cuit,
calle: orden.calle,
telefono: orden.telefono,
correoElectronico: orden.correoElectronico,
nombreVendedor: orden.nombreVendedor,
});
}
if (orden.articulos && orden.articulos.length > 0) {
setArticulos(orden.articulos.map(articulo => ({
nombre: articulo.nombre || '',
categoria: articulo.categoria || '',
tipoUnidad: articulo.tipoUnidad || '',
cantidadUnidades: articulo.cantidadUnidades || '',
tipoDivisa: articulo.tipoDivisa || orden.tipoDivisa || '',
precioUnidad: articulo.precioUnidad || '',
descuentoAplicado: articulo.descuentoAplicado || '',
})));
}
} catch (error) {
console.error('Error al cargar la orden de compra a editar:', error);
} finally {
setLoadingOrden(false);
}
};
cargarOrden();
}, [isEditing, id]);
const filteredProveedores =
query === ''
? proveedores
: proveedores.filter((proveedor) =>
proveedor.razonSocial
.toLowerCase()
.replace(/\s+/g, '')
.includes(query.toLowerCase().replace(/\s+/g, ''))
);
const formatCuit = (value) => {
const digits = value.replace(/\D/g, '');
if (digits.length <= 2) return digits;
if (digits.length <= 10) return `${digits.slice(0, 2)}-${digits.slice(2)}`;
return `${digits.slice(0, 2)}-${digits.slice(2, 10)}-${digits.slice(10, 11)}`;
};
const handleCuitChange = (e) => {
const formatted = formatCuit(e.target.value);
setFormData({
...formData,
cuit: formatted,
});
};
const handleArticuloChange = (e, index) => {
const { name, value } = e.target;
const newArticulos = [...articulos];
newArticulos[index][name] = value;
setArticulos(newArticulos);
};
const handleArticuloListboxChange = (name, value, index) => {
const newArticulos = [...articulos];
newArticulos[index][name] = value;
setArticulos(newArticulos);
};
const calcularMontoEstimado = () => {
let total = 0;
articulos.forEach(articulo => {
const cantidad = parseFloat(articulo.cantidadUnidades) || 0;
const precio = parseFloat(articulo.precioUnidad) || 0;
const descuento = parseFloat(articulo.descuentoAplicado) || 0;
const subtotal = cantidad * precio * (1 - descuento / 100);
total += subtotal;
});
return total;
};
useEffect(() => {
const nuevoMonto = calcularMontoEstimado();
setFormData(prev => ({
...prev,
montoEstimado: nuevoMonto,
}));
}, [articulos]);
const handleAddArticulo = () => {
setArticulos([
...articulos,
{
nombre: '',
categoria: '',
tipoUnidad: '',
cantidadUnidades: '',
tipoDivisa: formData.tipoDivisa,
precioUnidad: '',
descuentoAplicado: ''
},
]);
};
const handleRemoveArticulo = (index) => {
const newArticulos = articulos.filter((_, i) => i !== index);
setArticulos(newArticulos);
};
const handleChange = (e) => {
const { name, value } = e.target;
setFormData({ ...formData, [name]: value });
};
const generarPDFBlobOrden = async () => {
const input = ordenRef.current;
if (!input) {
console.error("No se encontró el elemento para generar el PDF.");
return null;
}
const canvas = await html2canvas(input, { scale: 2, useCORS: true });
const imgData = canvas.toDataURL('image/png');
const pdf = new jsPDF('p', 'mm', 'a4');
const imgProps = pdf.getImageProperties(imgData);
const pdfWidth = pdf.internal.pageSize.getWidth();
const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
return pdf.output('blob');
};
const handleSubmit = async (e) => {
e.preventDefault();
setIsLoading(true);
setSaveState('idle');
setErrorMsg('');
setProgress(0);
const user = getAuth().currentUser;
if (!user) {
setIsLoading(false);
return;
}
try {
const idToken = await user.getIdToken();
const datosParaEnviar = {
...formData,
articulos: articulos,
};
const interval = setInterval(() => {
setProgress((prev) => Math.min(prev + 5, 95));
}, 100);
const res = await fetch(
isEditing
? `https://backend-288175208699.europe-west1.run.app/editar-orden-compra/${id}`
: 'https://backend-288175208699.europe-west1.run.app/crear-orden-compra',
{
method: isEditing ? 'PUT' : 'POST',
headers: {
'Content-Type': 'application/json',
Authorization: `Bearer ${idToken}`,
},
body: JSON.stringify(datosParaEnviar),
});
clearInterval(interval);
const data = await res.json();
if (!res.ok) throw new Error(data.error || (isEditing ? 'Error al guardar los cambios' : 'Error al crear la compra'));
if (isEditing) {
// En edición no se regenera el PDF de la orden: el número no cambia.
setProgress(100);
setSaveState('saved');
setTimeout(() => {
navigate('/compras');
}, 800);
return;
}
const match = data.mensaje?.match(/ID\s+(\S+)/);
if (match && match[1]) {
const numeroDeOrden = match[1];
setNumeroOrden(numeroDeOrden);
setMostrarOrden(true);
await new Promise(resolve => setTimeout(resolve, 500));
const pdfBlob = await generarPDFBlobOrden();
if (pdfBlob) {
const storage = getStorage();
const fileRef = storageRef(storage, `facturas_compra/${numeroDeOrden}.pdf`);
await uploadBytes(fileRef, pdfBlob);
const downloadURL = await getDownloadURL(fileRef);
console.log("✅ PDF subido a Storage:", downloadURL);
}
setMostrarOrden(false);
}
setProgress(100);
setSaveState('saved');
setTimeout(() => {
navigate('/compras');
}, 800);
} catch (error) {
console.error(error);
setSaveState('error');
setErrorMsg(error.message || (isEditing ? 'Error al guardar los cambios' : 'Error al crear la compra'));
setIsLoading(false);
setProgress(0);
}
};
const tiposDivisa = ["Pesos", "Dólares", "Reales", "Euros"];
const abreviaturasDivisa = { Pesos: "$", "Dólares": "US$", Reales: "R$", Euros: "€" };
const modalidadesPago = ["Cheque", "Contado", "Tarjeta de credito", "Tarjeta de débito", "Transferencia"];
const tiposUnidad = ["Unidad", "Kilos", "Gramos", "Litro", "Centilitros", "Mililitros"];
const categorias = ["Activos", "Almacén", "Depósito", "Enología", "Finca", "Insumos", "Utilitarios"];
const abreviaturas = {
Unidad: "u", Kilos: "kg", Gramos: "gr", Litro: "lts",
Centilitros: "cl", Mililitros: "ml"
};
const handleTipoDivisaChange = (value) => {
setFormData({ ...formData, tipoDivisa: value });
const newArticulos = articulos.map(articulo => ({
...articulo,
tipoDivisa: value,
}));
setArticulos(newArticulos);
};
if (loadingOrden) {
return <LoadingSpinner />;
}
return (
<div style={{ padding: '0 16px',overflow:'hidden',height:'100%' }}>
<header className="trazabilidad-header">
<div className="header-content">
<h1>Compras</h1>
</div>
</header>
<div className="container" style={{ margin: '0 10px' }}>
<div className="formtitle-container">
<div className="formicon-container">
<ComprasIcon className="formicon" style={{ height: '20px', margin: 'auto' }} />
</div>
<h1 className="formtitle">{isEditing ? 'Editar orden de compra' : 'Orden de compra'}</h1>
</div>
<hr className="divider" />
<form onSubmit={handleSubmit} className="form">
<div className="columns-container">
<div className="column">
<label className='date-label'>Proveedor</label>
<div className="input-group">
{loadingProveedores ? (
<LoadingSpinner />
) : (
<Combobox
value={selectedProveedor}
onChange={(selected) => {
setSelectedProveedor(selected);
if (selected) {
setFormData((prev) => ({ ...prev, ...selected, razonSocial: selected.razonSocial }));
} else {
setFormData((prev) => ({
...prev,
razonSocial: '',
cuit: '',
calle: '',
telefono: '',
correoElectronico: '',
nombreVendedor: '',
}));
}
}}
>
{({ open }) => (
<>
<div style={{ position: 'relative' }}>
<Combobox.Button
as="div"
className={`custom-listbox-button ${open ? 'open' : ''} ${
selectedProveedor ? 'selected' : 'placeholder'
}`}
style={{paddingLeft:'0',paddingRight:'0'}}
>
<Combobox.Input
className="custom-combobox-input"
onChange={(event) => setQuery(event.target.value)}
displayValue={(proveedor) => proveedor?.razonSocial || ''}
placeholder="Selecciona o busca un proveedor"
style={{
flexGrow: 1,
padding: '0',
border: 'none',
outline: 'none',
backgroundColor: 'transparent',
paddingLeft:'15px'
}}
/>
<span className="custom-arrow-container" style={{marginRight:'5px'}}>
<span className="custom-arrow"></span>
</span>
</Combobox.Button>
<Combobox.Options className="custom-listbox-options" >
<Combobox.Option className="custom-listbox-option" key="none" value={null}>
Ninguno
</Combobox.Option>
{filteredProveedores.length === 0 && query !== '' ? (
<div className="custom-listbox-option">No se encontraron proveedores.</div>
) : (
filteredProveedores.map((p) => (
<Combobox.Option
key={p.cuit}
value={p}
className={({ active }) =>
`custom-listbox-option ${active ? 'active' : ''}`
}
>
{p.razonSocial}
</Combobox.Option>
))
)}
</Combobox.Options>
</div>
</>
)}
</Combobox>
)}
</div>
{!selectedProveedor && (
<>
<div className="input-group"><input type="text" name="razonSocial" placeholder="Razón social" value={formData.razonSocial} onChange={handleChange} className="input" /></div>
<div className="input-group"><input type="text" name="cuit" placeholder="CUIT" value={formData.cuit} onChange={handleCuitChange} maxLength={13} className="input" /></div>
<div className="input-group"><input type="text" name="calle" placeholder="Calle" value={formData.calle} onChange={handleChange} className="input" /></div>
<div style={{ display: 'flex', width: '100%', gap: '10px' }}>
<input type="text" name="altura" placeholder="Número" value={formData.altura} onChange={handleChange} className="input-address" />
<input type="text" name="piso" placeholder="Piso" value={formData.piso} onChange={handleChange} className="input-address" />
<input type="text" name="unidad" placeholder="Unidad" value={formData.unidad} onChange={handleChange} className="input-address" />
<input type="text" name="codigoPostal" placeholder="CP" value={formData.codigoPostal} onChange={handleChange} className="input-address" />
</div>
<div className="input-group"><input type="text" name="ciudad" placeholder="Ciudad / Localidad / Provincia" value={formData.ciudad} onChange={handleChange} className="input" /></div>
<div className="input-group"><input type="text" name="pais" placeholder="País" value={formData.pais} onChange={handleChange} className="input" /></div>
<div className="input-group"><input type="text" name="telefono" placeholder="Número de teléfono" value={formData.telefono} onChange={handleChange} className="input" /></div>
<div className="input-group"><input type="email" name="correoElectronico" placeholder="Correo electrónico" value={formData.correoElectronico} onChange={handleChange} className="input" /></div>
<div className="input-group"><input type="text" name="nombreVendedor" placeholder="Nombre del vendedor" value={formData.nombreVendedor} onChange={handleChange} className="input" /></div>
</>
)}
</div>
<div className="column long">
{articulos.map((articulo, index) => (
<>
<div className='input-group'>
<input
type="text"
name="nombre"
placeholder="Descripción del articulo"
value={articulo.nombre}
onChange={(e) => handleArticuloChange(e, index)}
className="input"
/>
</div>
<div className="input-group">
<Listbox
value={articulo.categoria}
onChange={(value) => handleArticuloListboxChange('categoria', value, index)}
>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${articulo.categoria ? 'selected' : 'placeholder'}`}>
{articulo.categoria || "Categoría"}
<span className="custom-arrow-container">
<span className="custom-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{categorias.map((option) => (
<ListboxOption key={option} value={option} className="custom-listbox-option">
{option}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
<div className="input-group">
<Listbox
value={articulo.tipoUnidad}
onChange={(value) => handleArticuloListboxChange('tipoUnidad', value, index)}
>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${articulo.tipoUnidad ? 'selected' : 'placeholder'}`}>
{articulo.tipoUnidad || "Tipo de unidad"}
<span className="custom-arrow-container">
<span className="custom-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{tiposUnidad.map((option) => (
<ListboxOption key={option} value={option} className="custom-listbox-option">
{option}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
<div className='input-group number'>
<input
type="number"
name="cantidadUnidades"
placeholder="Cantidad de unidades"
value={articulo.cantidadUnidades}
onChange={(e) => handleArticuloChange(e, index)}
className="input"
/>
<span className="unit">{articulo.tipoUnidad ? abreviaturas[articulo.tipoUnidad] : ""}</span>
</div>
<div className="input-group">
<Listbox value={formData.tipoDivisa} onChange={handleTipoDivisaChange}>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${formData.tipoDivisa ? 'selected' : 'placeholder'}`}>
{formData.tipoDivisa || "Tipo de divisa"}
<span className="custom-arrow-container">
<span className="custom-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{tiposDivisa.map((option) => (
<ListboxOption key={option} value={option} className="custom-listbox-option">
{option}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
<div className='input-group number'>
<input
type="number"
name="precioUnidad"
placeholder="Precio unitario"
value={articulo.precioUnidad}
onChange={(e) => handleArticuloChange(e, index)}
className="input"
/>
<span className="unit">{abreviaturasDivisa[formData.tipoDivisa] || "$"}/{articulo.tipoUnidad ? abreviaturas[articulo.tipoUnidad] : ""}</span>
</div>
<div className='input-group number'>
<input
type="number"
name="descuentoAplicado"
placeholder="Descuento aplicado"
value={articulo.descuentoAplicado}
onChange={(e) => handleArticuloChange(e, index)}
className="input"
/>
<span className="unit">%</span>
</div>
{ }
{articulos.length > 1 && (
<button type="button" onClick={() => handleRemoveArticulo(index)} className="remove-btn">
Eliminar artículo
</button>
)}
<div type="button" onClick={handleAddArticulo} className="add-btn-container">
<span className="add-icon">+</span><span className="add-txt">
Agregar artículo</span></div></>
))}
</div>
<div className="column long">
<span className="data-label">Domicilio de residencia</span>
<div className="input-group">
<input
type="text"
name="entregacalle"
placeholder="Calle"
value={formData.entregacalle}
onChange={handleChange}
className="input"
/>
</div>
<div style={{ display: 'flex', width: '100%', gap: '10px' }}>
<input
type="text"
name="entregaaltura"
placeholder="Número"
value={formData.entregaaltura}
onChange={handleChange}
className="input-address"
/>
<input
type="text"
name="entregaPiso"
placeholder="Piso"
value={formData.entregaPiso}
onChange={handleChange}
className="input-address"
/>
<input
type="text"
name="entregaunidad"
placeholder="Unidad"
value={formData.entregaunidad}
onChange={handleChange}
className="input-address"
/>
<input
type="text"
name="entregaCodigoPostal"
placeholder="CP"
value={formData.entregaCodigoPostal}
onChange={handleChange}
className="input-address"
/>
</div>
<div className="input-group">
<input
type="text"
name="entregaCiudad"
placeholder="Ciudad / Localidad / Provincia"
value={formData.entregaCiudad}
onChange={handleChange}
className="input"
/>
</div>
<div className="input-group">
<input
type="text"
name="entregaPais"
placeholder="País"
value={formData.entregaPais}
onChange={handleChange}
className="input"
/>
</div>
<div className="input-group">
<Listbox value={formData.modalidadPago} onChange={(value) => setFormData({ ...formData, modalidadPago: value })}>
{({ open }) => (
<>
<ListboxButton className={`custom-listbox-button ${open ? 'open' : ''} ${formData.modalidadPago ? 'selected' : 'placeholder'}`}>
{formData.modalidadPago || "Modalidad de pago"}
<span className="custom-arrow-container">
<span className="custom-arrow"></span>
</span>
</ListboxButton>
<ListboxOptions className="custom-listbox-options">
{modalidadesPago.map((option) => (
<ListboxOption key={option} value={option} className="custom-listbox-option">
{option}
</ListboxOption>
))}
</ListboxOptions>
</>
)}
</Listbox>
</div>
<div className="input-group">
<input
type="text"
name="montoEstimado"
placeholder="Monto estimado"
value={formData.montoEstimado.toLocaleString('es-AR', {
minimumFractionDigits: 0,
maximumFractionDigits: 0,
})}
onChange={handleChange}
className="input"
readOnly
/>
</div>
<div className="button-container">
<hr style={{ border: "0", borderTop: "1px solid #eaeef5", margin: "0px 0 0px" }} />
<button type="submit" className={`button ${saveState === 'saved' ? 'success' : ''}`} disabled={isLoading}>
<span className="button-text">
{saveState === 'saved'
? 'Guardado'
: isEditing ? (isLoading ? 'Guardando...' : 'Guardar cambios') : (isLoading ? 'Creando...' : 'Crear')}
</span>
{isLoading && (
<span className="progress-bar" style={{ width: `${progress}%` }}></span>
)}
</button>
{saveState === 'error' && errorMsg && (
<p className="form-error-message">{errorMsg}</p>
)}
</div>
</div>
</div>
</form>
</div>
{mostrarOrden && (
<div style={{
position: 'fixed',
top: 0,
left: 0,
width: '0%',
height: '0%',
backgroundColor: 'rgba(0, 0, 0, 0.5)',
display: 'flex',
justifyContent: 'center',
alignItems: 'center',
zIndex: 1000
}}>
<div style={{
position: 'relative',
width: '210mm',
height: '297mm',
overflowY: 'auto'
}}>
<OrdenCompra
ref={ordenRef}
datosProveedor={selectedProveedor || formData}
datosArticulos={articulos}
datosEntrega={formData}
numeroOrden={numeroOrden}
modalidadPago={formData.modalidadPago}
fechaEmision={new Date().toLocaleDateString()}
abreviaturas={abreviaturas}
formData={formData}
/>
<div style={{ marginTop: '20px', textAlign: 'center' }}>
<button onClick={() => setMostrarOrden(false)}>Cerrar</button>
</div>
</div>
</div>
)}
</div>
);
};
export default OCForm;